import { reactive, readonly } from "vue";

const state = reactive({
  count: 0,
});

export function acquireGlobalLoader() {
  state.count += 1;
}

export function releaseGlobalLoader() {
  state.count = Math.max(0, state.count - 1);
}

export function isGlobalLoaderVisible() {
  return state.count > 0;
}

export function getGlobalLoaderState() {
  return readonly(state);
}
